<template>
  <div>
    <SectionTitle
      class="border-s-200 mb-[18px] !border-l-0 border-b-2 lg:text-xl"
      :title="sectionData.title"
      :hide-button="hideButton"
      @view-more-click="$emit('viewMoreClick', sectionData)"
    />
    <div class="relative md:overflow-hidden">
      <div
        class="grid w-full grid-cols-1 justify-items-center gap-2 py-1 md:grid-cols-3 2xl:grid-cols-4"
      >
        <VideoCard
          v-for="(video, i) in videos"
          :key="video.id"
          class="shrink-0 md:!max-w-full"
          :index="i"
          :slug="video.slug"
          :title="video.title"
          :excerpt="video.excerpt"
          :duration="video.duration"
          :published-date="video.publishedDate"
          :cover-url="video.backgroundImage"
          :vimeo-id="video.vimeoId"
          :preview-vimeo-id="video.previewVimeoId"
          @play="handlePlay(video)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useScreenSize } from '~/composables/useScreenSize'
import SectionTitle from '~/components/portals/SectionTitle.vue'
import VideoCard from '~/components/portals/VideoCard.vue'
import type { TGeneral } from '~/src/types/common'

const props = withDefaults(
  defineProps<{
    sectionData: TGeneral
    hideButton?: boolean
  }>(),
  {
    hideButton: false,
  },
)

const emit = defineEmits<{
  (event: 'viewMoreClick' | 'play', data: TGeneral): void
}>()

const { isBigDesktop, isMobile } = useScreenSize()

const videos = computed<TGeneral[]>(() => {
  if (isBigDesktop.value || isMobile.value) {
    return props.sectionData.videos || []
  }
  return (props.sectionData.videos || []).slice(0, 3)
})

const handlePlay = (vimeoData: TGeneral): void => {
  emit('play', vimeoData)
}
</script>
